import { DialogActions, Modal, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { type FC, useState } from "react";
import { useChosenDepartment } from "../../../../contexts/ChosenDepartment";
import { useFormatPersonName } from "../../../../hooks/useNameFormat";
import { useRosterNurse } from "../../../../hooks/useNurses";
import { SystemValidationTextField } from "../../../UIToolkit/Inputs/SystemValidationTextField";
import SystemButton from "../../../UIToolkit/SystemButton/SystemButton";
import { useDirectMessages } from "./useDirectMessages";

type DirectMessageProps = {
	open: boolean;
	nurseId: number;
	onClose: () => void;
	initialMessage?: string;
};

export const DirectMessage: FC<DirectMessageProps> = ({ open, nurseId, onClose, initialMessage }) => {
	const { handleSendMessage, isLoading, isSuccess } = useDirectMessages({
		onClose,
	});
	const { chosenDepartment } = useChosenDepartment();
	const nurse = useRosterNurse(chosenDepartment.department_id, nurseId);
	const formatPersonName = useFormatPersonName();

	const [message, setMessage] = useState<string>(initialMessage ?? "");

	return (
		<Modal open={open} onClose={onClose}>
			<Box
				sx={{
					display: "flex",
					height: "100vh",
					width: "100vw",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						alignItems: "start",
						justifyContent: "center",
						gap: 3,
						padding: 5,
						bgcolor: "#fff",
						borderRadius: 2,
						height: "fit-content",
						width: "50%",
					}}
				>
					<Box sx={{ display: "flex", gap: 1 }}>
						<Typography sx={{ fontWeight: 600, fontSize: "26px", color: "primary.main" }}>Send Direct Message To</Typography>
						<Typography sx={{ fontWeight: 600, fontSize: "26px", color: "primary.dark" }}>
							{/* DEFAULT: no name until the roster loads; Send stays disabled meanwhile. */}
							{nurse ? formatPersonName(nurse) : ""}
						</Typography>
					</Box>
					<Box
						style={{
							border: "1px solid #E3E4F0",
						}}
						sx={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							gap: 1,
							padding: 2,
							borderRadius: 1,
							width: "100%",
							color: "primary.dark",
						}}
					>
						<SystemValidationTextField
							variant={"standard"}
							reserveHeightForHelperText={false}
							injectedProps={{
								multiline: true,
								rows: 5,
								slotProps: {
									htmlInput: {
										style: {
											scrollbarWidth: "thin",
											scrollbarColor: "#888 transparent",
										},
									},
								},
							}}
							value={message}
							onChange={(e) => setMessage(e.target.value)}
							placeholder={"Type your message here..."}
						/>
					</Box>

					<DialogActions sx={{ justifyContent: "flex-end", width: "100%", padding: 0 }}>
						<SystemButton buttonVariant={"secondary"} onClick={onClose}>
							Cancel
						</SystemButton>
						<SystemButton disabled={isLoading || !nurse} onClick={() => nurse && handleSendMessage(message, nurse)} loading={isLoading || isSuccess}>
							Send
						</SystemButton>
					</DialogActions>
				</Box>
			</Box>
		</Modal>
	);
};
